import { Component, inject } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { IntroductionBoxComponent } from '../../../../../core/introduction-box/introduction-box.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { AppButtonComponent } from '@htx/core';

@Component({
  selector: 'app-assets',
  imports: [TranslocoPipe, AppButtonComponent, RouterOutlet, IntroductionBoxComponent],
  templateUrl: './asset.component.html'
})
export class AssetComponent {
  protected router = inject(Router);

  public goToCreateAssetPage(): Promise<boolean> {
    return this.router.navigate(['/assets/create']);
  }
}
